import { isOneSiteDemoFlow } from "@/lib/one-site-demo"
import { canAccessInstituteManagement } from "@/lib/workspace-rbac"

/**
 * Institute management row on `/home`.
 *
 * Tenet admins only. Hidden for Exxat One Site and other non-institute demos.
 * Never listed under Request access; Spotlight shows Open when this is true.
 */
export function showsInstituteManagementOnHome(): boolean {
  if (!canAccessInstituteManagement()) return false
  if (isOneSiteDemoFlow()) return false
  return true
}
